import { useState } from 'react'
import { COLORS, TYPE } from './tokens'

const OPTIONS = [
  {
    id: 'mid_term',
    title: 'Mid-term update',
    desc: 'Same policy period. New endorsement, updated BIA, or changed threat profile.'
  },
  {
    id: 'renewal',
    title: 'Renewal',
    desc: 'New policy term. Creates a fresh anchor. The previous term is marked expired.'
  },
  {
    id: 'post_incident',
    title: 'Post-incident',
    desc: 'After a claim or event. Findings prioritize incident-specific coverage.'
  }
]

export default function RunNewReviewButton({ isOpen, submitting, onOpen, onClose, onSubmit }) {
  const [kind, setKind] = useState('mid_term')

  return (
    <>
      <button
        onClick={onOpen}
        style={{
          ...TYPE.body, width: '100%', padding: '10px 16px',
          background: 'transparent', color: COLORS.bodyText,
          border: `1px solid ${COLORS.hairline}`, borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Run new review
      </button>
      {isOpen && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(1, 36, 56, 0.4)',
          display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
          paddingTop: '120px', zIndex: 100
        }}>
          <div style={{
            background: COLORS.panelBg, width: '520px', borderRadius: '8px',
            padding: '32px', boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
          }}>
            <h3 style={{ fontSize: '22px', fontWeight: 500, margin: '0 0 20px' }}>
              Run new review
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '24px' }}>
              {OPTIONS.map(o => (
                <div
                  key={o.id}
                  onClick={() => setKind(o.id)}
                  style={{
                    padding: '14px 16px',
                    border: `1px solid ${kind === o.id ? COLORS.accent : COLORS.hairline}`,
                    borderRadius: '4px',
                    background: kind === o.id ? 'rgba(138, 208, 214, 0.06)' : 'transparent',
                    cursor: 'pointer',
                    display: 'flex', gap: '12px'
                  }}
                >
                  <span style={{
                    width: '16px', height: '16px', borderRadius: '50%',
                    border: `1.5px solid ${kind === o.id ? COLORS.accent : COLORS.hairline}`,
                    marginTop: '3px', flexShrink: 0,
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                  }}>
                    {kind === o.id && (
                      <span style={{
                        width: '8px', height: '8px', borderRadius: '50%',
                        background: COLORS.accent
                      }} />
                    )}
                  </span>
                  <div>
                    <div style={{ ...TYPE.body, fontWeight: 500 }}>{o.title}</div>
                    <div style={{ ...TYPE.supporting, color: COLORS.mutedText, marginTop: '4px' }}>{o.desc}</div>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button
                onClick={onClose}
                disabled={submitting}
                style={{
                  ...TYPE.body, padding: '8px 16px',
                  background: 'transparent', color: COLORS.bodyText,
                  border: `1px solid ${COLORS.hairline}`, borderRadius: '4px',
                  cursor: submitting ? 'wait' : 'pointer'
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => onSubmit({ kind })}
                disabled={submitting}
                style={{
                  ...TYPE.body, padding: '8px 16px',
                  background: COLORS.retentionBg, color: COLORS.retentionText,
                  border: 'none', borderRadius: '4px',
                  cursor: submitting ? 'wait' : 'pointer'
                }}
              >
                {submitting ? 'Starting…' : 'Continue → upload'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
